import React, { Component } from 'react';
import Navbar from './Navbar/Navbar';
import Routes from './Routes';
import { Router } from 'react-router'
import { createBrowserHistory } from 'history'
import Footer from "./Footer";

class App extends Component {
    constructor(props){
        super(props);

        this.goHome = this.goHome.bind(this);
    }

    goHome(e){
        this.homeLink.click()

    }

    render(){
        const history = createBrowserHistory();

        return(
            <Router history={history}>
                <a style={{display: 'none'}} href="/" ref={homeLink => this.homeLink = homeLink}>
                </a>
                <div className="main">
                    <div id="navbarIcon">
                        <h1 id="navbarIconHeading" onClick={this.goHome}><i className="fas fa-book-reader" /> UNIQUE TUTORIALS</h1>
                        <div id="navbarContactDiv">
                            <h3 id="navbarContactInfo">
                                <a href="tel:+17326329690" id="navbarContactNumber" style={{textDecoration: 'none', color: 'orangered'}}><i className="fa fa-phone" aria-hidden="true" />  +1-732-632-9690</a>
                                <a href="mailto:info@unique-tutorials.com" id="navbarContactEmail" style={{textDecoration: 'none', color: '#6C63FF'}}><i className="fa fa-envelope" aria-hidden="true" /> info@unique-tutorials.com</a>
                            </h3>
                        </div>
                    </div>
                    <div id="navbarDiv">
                        <Navbar/>
                    </div>
                    <div id="display">
                        <Routes />
                    </div>
                    <div id="footer">
                        <Footer/>
                    </div>
                </div>
            </Router>
        )
    }
}

export default App;
